/*
 * @Author: Josselin Hubert
 * @Date: 2020-09-02 13:30:42
 * @Last Modified by:   Josselin Hubert
 * @Last Modified time: 2020-09-02 13:30:42
 */


<template>
  <section id="home">
    <hero />
    <contents />
  </section>
</template>

<script>
  export default {
    name: "SkillsIndex",

    metaInfo: {
      title: "Premium Development",
    },

    components: {
      Hero: () => import("./Hero"),
      Contents: () => import("./Contents"),
    },
  };
</script>
